import React, { Component } from 'react'

export default class GreetingTemplate extends Component {

  state = {
    banco: '',
    text1: '¡Muchas gracias por completar todos los datos!',
    text2: '¿No fue tanto trabajo, no? Con la información que nos diste ya estamos calificando tu negocio. Dentro de las próximas 24hs hábiles horas te vamos hacer una oferta de línea de crédito. ',

  }

  componentDidMount() {
    let banco = window.location.pathname.split('/')[1];
    this.setState({ banco: banco })
    if (banco !== 'iaja') {
      // this.setState({ redirect: true, banco: banco, baseUrl: baseUrl, pathName: pathName })
    }
  }
  componentWillMount() {
    let banco = window.location.pathname.split('/')[1];
    this.setState({ banco: banco })
    if (banco !== 'iaja') {
      // this.setState({ redirect: true, banco: banco, baseUrl: baseUrl, pathName: pathName })
    }
  }
  render() {
    return (
      <div>
        {this.state.banco !== 'iaja' ?
          <div>
            <h1>¡Muchas gracias por completar todos los datos!</h1>
            <br />
            <h3>¿No fue tanto trabajo, no? Con la información que nos diste ya estamos calificando tu negocio. Dentro de las próximas 24hs hábiles horas te vamos hacer una oferta de línea de crédito. </h3>
            <br />
            <h3>¿Tenés alguna duda? Podés escribirnos a <a href="mailto:info@credility.com?subject=Consulta%20Onboarding">info@credility.com</a>.</h3>
            <br />
            <div>
              <h4>Saludos Cordiales&nbsp; <br />El equipo de Credility.</h4>
            </div>
          </div> :
          <div>
            <h1>¡Muchas gracias por completar todos los datos!</h1>
            <br />
            <h3>¿No fue tanto trabajo, no? Con la información que nos diste ya estamos calificando tu negocio. Dentro de las próximas 24hs hábiles horas te vamos hacer una oferta de línea de crédito. </h3>
            <br />
            <h3>¿Tenés alguna duda?</h3>
            <h3>Por consultas con la carga de información escribinos a <a href="mailto:info@credility.com?subject=Consulta%20Onboarding">info@credility.com</a>.</h3>
            <h3>Por cualquier otra consulta escribinos a <a href="mailto:hola@iaja.com?subject=Consulta%20Onboarding">hola@iaja.com</a>.</h3>
          </div>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/GreetingTemplate.js